import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-wizard', 'completedStep', 'Samm täidetud');
Labels.set('ui-wizard', 'next', 'Edasi');
Labels.set('ui-wizard', 'back', 'Tagasi');
